<template>
    <div @click="linkClicked">
        <div v-for="(item, index) in items" class="accordion-row row" :key="index">
            <div class="col-12">
                <strong @click="setActive(index)">
                    <i class="icon icon-16 ml-2" :class="active === index ? 'icon-minus' : 'icon-plus'"></i>
                    <!--<animate-plus :active="active === index" />-->
                    <span>{{ $t(item.title) }}</span>
                </strong>

                <transition name="slide">
                    <div v-if="active === index">
                        <p v-html="$t(item.description)"></p>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Accordion',
    props: {
        items: {
            type: Array,
            required: true,
        }
    },
    data: () => ({
        active: null
    }),
    methods: {
        setActive(index) {
            if (this.active === index) {
                this.active = null;
            }
            else {
                this.active = index;
            }
        },

        linkClicked(e) {
            if (e.target.matches('a')) {
                let target = e.target.getAttribute('data-target');

                this.setActive(parseInt(target));
            }
        }
    },
}
</script>

<style scoped>
.accordion-row {
    margin-bottom: 15px;
}

.accordion-row strong {
    cursor: pointer;
}

.accordion-row strong span {
    font-weight: 300;
    color: #212121;
    user-select: none;
}

.accordion-row p {
    border-radius: 5px;
    background-color: #f3f3f3;
    padding: 30px;
    margin-top: 15px;
    color: #585858;
    font-size: 16px;
    font-weight: 300;
}

>>> .accordion-row p a {
    color: #0ea960 !important;
}

.slide-enter-active {
    transition-duration: 0.3s;
    transition-timing-function: ease-in;
}

.slide-leave-active {
    transition-duration: 0.3s;
    transition-timing-function: ease-out;
}

.slide-enter-to, .slide-leave {
    max-height: 1000px;
    overflow: hidden;
}

.slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
}

@media (max-width: 991.98px) {
    .accordion-row {
        margin-bottom: 20px;
    }
}
</style>
